var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OrderConfirmation"},[_c('p',[_vm._v("Totale kosten: € xxx + € "+_vm._s(_vm.additional)+" = € zzz")]),_c('FieldSet',{attrs:{"label":_vm.label,"values":_vm.values,"fields":_vm.fields,"validation":_vm.validation,"layout":_vm.layout,"disabled":_vm.disabled,"path":_vm.path}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }